// extracted by mini-css-extract-plugin
export var boxItems = "_am-1";
export var boxItemsLg = "_am-2";
export var button = "_am-7";
export var buttonHoverless = "_am-9";
export var buttonLg = "_am-8";
export var filterGroupBox = "_am-0";
export var icon = "_am-3";
export var iconSecondary = "_am-6";
export var iconWrapper = "_am-4";
export var iconWrapperLg = "_am-5";
export var truncatedLabel = "_am-a";